<!--
    Name:			OrderDetail.vue

    Description:	Show the orderdetails in an overlay.
                    Used in for example the order.vue

    Remarks:
-->

<template>
    <div :class="accentClass">

        <!-----------------
        | ORDER STATUS
        ------------------>
        <div class="orderinfo accent-background panel">
            <div class="ordernr">{{Order.orderNr}}&nbsp;<span style="float:right">{{Order.name}}</span></div>
            <div class="order-prop"><span class="label"><translate item="OrderDetail.OrderStatus.Created" /></span>: {{Order.createDate | formatDayTime}}</div>
            <div class="order-prop"><span class="label"><translate item="OrderDetail.OrderStatus.Preparation" /></span>: {{Order.startDate | formatTime}} - {{Order.calculatedReadyDate | formatTime}}</div>
            <div class="order-prop">
                <span class="label"><translate item="OrderDetail.OrderStatus.RequestedReadyTime" /></span>:
                <span v-if="Order.desiredReadyDate != null">{{Order.desiredReadyDate | formatDayTime}}</span><span v-else><translate item="OrderDetail.OrderStatus.RequestedReadyTime.ASAP" /></span>
            </div>
            <div class="order-prop order-delivery">
                <span v-if="Order.deliveryMethod == 0"><translate item="OrderDetail.OrderStatus.DeliveryMethod.EatHere" /> </span>
                <span v-if="Order.deliveryMethod == 1"><translate item="OrderDetail.OrderStatus.DeliveryMethod.PickUp" /> </span>
                <span v-if="Order.deliveryMethod == 2"><translate item="OrderDetail.OrderStatus.DeliveryMethod.Deliver" /> </span>
            </div>
        </div>

        <div class="content-in">

            <!-----------------
            | PRODUCT OVERVIEW
            ------------------>
            <div class="products p-2">
                <template class="menu-holder" v-for="product in dishGroupHolderProducts">
                    <div :class="['product-name mnu', getProductClass(product, false)]">{{product.quantity}} {{product.name}}	</div>
                    <div :class="['mnu-child', getProductClass(child, false)]" :key="child.id" v-for="child in product.children">
                        {{child.quantity}} {{child.name}} <span :class="getProductClass(prep, true)" :key="prep.id" v-for="prep in child.children">  + {{prep.quantity > 1 ? prep.quantity + ' ' : ''}} {{prep.name}}</span>
                    </div>
                </template>

                <div :key="product.id" v-for="product in normalProducts">
                    <div :class="getProductClass(product)">
                        {{product.quantity}} {{product.name}} <span :class="getProductClass(prep, true)" :key="prep.id" v-for="prep in product.children">  + {{prep.quantity > 1 ? prep.quantity + ' ' : ''}} {{prep.name}}</span>
                    </div>
                </div>
            </div>

            <!-----------------
            | RE-SCHEDULE
            ------------------>
            <div v-if="rescheduleReady" class="panel">
                <hr />
                <div class="reschedule text-left">

                    <h5><translate item="OrderDetail.OrderStatus.Reschedule.Title" /></h5>
                    <p><translate item="OrderDetail.OrderStatus.Reschedule.Content" /></p>

                </div>
                <div>
                    <div class="">
                        <div class="row">
                            <div class="col-4 offset-4 text-left">
                                <h5 class="time-h5" v-if="!rescheduleDone"><translate item="OrderDetail.OrderStatus.Reschedule.Available" />:</h5>
                            </div>
                        </div>
                        
                        <div class="row">

                            <div class="col-4 text-left">
                                <select class="dropdown form-control" v-model="selectedTime" v-on:change="rescheduleTimeChanged">
                                    <option class="dropdown-item" v-for="(time,index) in times" :key="time" :value="time">{{ time }}</option>
                                </select>

                            </div>
                            <div class="col-4 text-left">
                  
                                <div class="rescheduleConfirm">

                                    <div v-if="rescheduleloading" class="rescheduleloader"><translate item="OrderDetail.OrderStatus.Reschedule.Loading" /></div>
                                    <div v-if="!rescheduleloading && rescheduleFirstDateTime != null" class="reschedulefirstdate">{{rescheduleFirstDateTime  | formatTime}} <translate item="OrderDetail.OrderStatus.Reschedule.Hour" /></div>
                                    <button class="btn btn-dark" v-on:click="reschedule" v-if="!rescheduleDone"><translate item="OrderDetail.OrderStatus.Reschedule.Confirm" /></button>
                                    <div class="rescheduleDone" v-if="rescheduleDone"><translate item="OrderDetail.OrderStatus.Reschedule.Confirmed" /> <span class="icon icon-gereed-klant"></span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-----------------
            | REMARKS
            ------------------>
            <div class="panel" v-if="remarksDirect.length">
                <hr />
                <div class="text-left" v-for="remark in remarksDirect">
                    {{remark.remark}}
                </div>
            </div>

            <div class="more-bar text-right" v-if="MoreColapsed" v-on:click="MoreColapsed = !MoreColapsed">
                <span class="btn btn-link"><translate item="OrderDetail.OrderStatus.MoreInformation" /></span>
            </div>

            <div class="more panel text-left" v-if="!MoreColapsed">
                <hr />
                <h5><translate item="OrderDetail.OrderStatus.Planning" /></h5>

                <div class="row" v-if="Order.desiredReadyDate != null">
                    <span class="col-4  text-right">
                        <translate item="OrderDetail.OrderStatus.RequestedReadyTime" />
                    </span>
                    <span class="col-8 text-left">
                        {{Order.desiredReadyDate | formatTime}}
                    </span>
                </div>

                <div class="row">
                    <span class="col-4 ">
                        <translate item="OrderDetail.OrderStatus.Preparation" />
                    </span>
                    <span class="col-8 text-left">
                        {{Order.startDate | formatTime}} - {{Order.calculatedReadyDate | formatTime}}
                    </span>
                </div>


                <div class="row " v-for="batch in detailedBatches" :key="batch.id">
                    <span class="col-4">
                        {{batch.name}} #{{batch.basket.nr}}
                    </span>
                    <div class="col-3 text-left">
                        {{batch.startTime}} - {{batch.endTime}}

                    </div>
                    <div class="col-5 text-left">
                        <div :key="product.id" v-for="product in batch.source.products"><!--{{product.quantity}}-->{{product.name}}</div>
                    </div>
                </div>

                <div v-if="remarksAll && remarksAll.length">
                    <hr />
                    <h5>
                        <translate item="OrderDetail.OrderStatus.Remarks" />
                    </h5>
                    <div class="text-left" v-for="remark in remarksAll">
                        {{remark.remark}}
                    </div>
                </div>

                <div :key="address.id" v-for="address in Addresses">
                    <hr />
                    <h5 v-if="address.addressTypeId == 0"><translate item="OrderDetail.OrderStatus.AddressInfo.ShippingAddress" /></h5>
                    <h5 v-if="address.addressTypeId == 1"><translate item="OrderDetail.OrderStatus.AddressInfo.BillingAddress" /></h5>

                    <div class="row">
                        <span class="col-4 ">
                            <translate item="OrderDetail.OrderStatus.AddressInfo.Name" />
                        </span>
                        <span class="col-8 ">
                            {{Order.name}}
                        </span>
                    </div>
                    <div class="row">
                        <span class="col-4">
                            <translate item="OrderDetail.OrderStatus.AddressInfo.Address" />
                        </span>
                        <span class="col-8">
                            {{address.address1}}
                            <span v-if="address.address2"><br />{{address.address2}}</span>
                        </span>
                        <span class="col-4">
                            <translate item="OrderDetail.OrderStatus.AddressInfo.City" />
                        </span>
                        <span class="col-8">
                            {{address.city}}
                        </span>
                        <span class="col-4">
                            <translate item="OrderDetail.OrderStatus.AddressInfo.Zipcode" />
                        </span>
                        <span class="col-8">
                            {{address.zipPostalCode}}
                        </span>
                        <span class="col-4">
                            <translate item="OrderDetail.OrderStatus.AddressInfo.Phonenumber" />
                        </span>
                        <span class="col-8">
                            {{address.phoneNumber}}
                        </span>
                        <span class="col-4">
                            <translate item="OrderDetail.OrderStatus.AddressInfo.Name" />
                        </span>
                        <span class="col-8">
                            {{address.firstName}} {{address.lastName}}
                        </span>
                        <span class="col-4">
                            <translate item="OrderDetail.OrderStatus.AddressInfo.Email" />
                        </span>
                        <span class="col-8">
                            {{address.email}}
                        </span>
                        <span class="col-4">
                            <translate item="OrderDetail.OrderStatus.AddressInfo.Company" />
                        </span>
                        <span class="col-8">
                            {{address.company}}
                        </span>
                    </div>
                </div>

                <div>
                    <hr />
                    <div class="more-bar text-right" v-on:click="MoreColapsed = !MoreColapsed">
                        <span class="btn btn-link"><translate item="OrderDetail.OrderStatus.LessInformation" /></span>
                    </div>

                </div>

            </div>
        </div>


        <div class="alert-buttons panel">
            <div class="text-left">
                <div class="btn btn-dark" v-on:click="close"><translate item="General.Close" /></div>
                <div class="btn btn-danger" v-if="!MoreColapsed" v-on:click="deleteOrder"><translate item="OrderDetail.Panel.DeleteOrder" /></div>
            </div>

            <div :key="status" v-if="!Order.fromHistorySearch" v-for="status in StatusIds" :class="getAccentClass(status)" v-on:click.stop="setStatus(status)">
                <div class='btn btn-accent'>
                    <span>
                        <i v-if="status == Order.status" class="icon icon-checkmark-small"></i>
                        <i v-if="status != Order.status" class="icon-number">{{status + 1}}</i>
                    </span>
                </div>
            </div>
        </div>

    </div>
</template>
<style>
</style>
<script>

   
    import configRepository from '../repositories/ConfigRepository';
    import { ShowOn } from '../repositories/Constants';
    import { OrderStatus, BatchStatus } from "../repositories/Constants";
    import rescheduleRepository from '../repositories/RescheduleRepository';
    import axios from 'axios';
    import Vue from 'vue';
    import Swal from "sweetalert2";
    import translate from '../components/translate'

    let options = {
        //weekday: "long", year: "numeric", month: "short",
        //day: "numeric",
        hour: "2-digit", minute: "2-digit"
    };

    const orderDetail = {

        components: { translate },

        data: function () {
            return {
                Addresses: []
                , MoreColapsed: true
                , StatusIds: configRepository.statusIds
                , selectedTime: {}
                , timeIntervals: []
                , rescheduleloading: false
                , rescheduleFirstDateTime: null
                , rescheduleDone: false
                , rescheduleReady: false

            }
        },

        props: {
            Order: { type: Object },
            Message: { type: String },
            Units: { type: Object }
        },

        created: function () {

            var _this = this;

            // get addresses
            axios({
                method: 'GET',
                url: configRepository.endPointUrl + 'api/hub/GetAddressList/' + this.Order.id,
                withCredentials: true
            }).then(function (response) {
                if (response.data.success) {
                    Vue.set(_this, 'Addresses', response.data.data);
                }
            }).catch(function (err) {
                window.console.error('error fetching addresses from server');
                window.console.error(err);
            });
        },

        methods: {
            getProductBeginTime: function (product) {
                if (!product.batches.length) {
                    return "-";
                }
                return product.batches.reduce(function (a, b) { return a.startTime < b.startTime ? a : b; }).startTime.toLocaleTimeString("nl-nl", options);//  product.batches[0].startTime.toLocaleTimeString("nl-nl", options);
            },

            getProductEndTime: function (product) {
                if (!product.batches.length) {
                    return "-";
                }
                return product.batches.reduce(function (a, b) { return a.endTime > b.endTime ? a : b; }).endTime.toLocaleTimeString("nl-nl", options);
            },

            getProductClass: function (product, isPrepMethod) {

                var className = {};

                //// shortcut.
                if (isPrepMethod && product.prepMethodPlanAction == 0) {
                    return className;
                }

                className['product-name'] = 1;
                if (this.Units == null) {
                    // pick screen
                    className['unit-active'] = 1;
                } else if (typeof this.Units == undefined) {
                    //  console.log('units undefined');
                    className['unit-active'] = 1;
                }
                else {
                    try {
                        if (product.isDishGroupholder) {
                            if (product.children && this.Units.some(a => product.children.some(c => c.batches && c.batches.some(b => b.unitGroupId == a.id)))) {
                                className['unit-active'] = 1;
                            }
                        }
                        else {
                            if (product.batches && this.Units.some(a => product.batches.some(b => b.unitGroupId == a.id))) {
                                className['unit-active'] = 1;
                            }
                        }
                    } catch (e) {
                        className['unit-error'] = 1;

                        if (!window.localStorage.getItem('reload_productId' + product.id)) {
                            window.localStorage.setItem('reload_productId' + product.id, '1');
                            logRepostory.addLog('Reload browser, batch not found for order' + this.Order.orderNr);
                            window.location.reload(true);
                        }
                    }

                }
                return className;
            },
            getProductBatches: function (product) {
                var _batches = [];

                if (product.batches && product.batches.length) {
                    product.batches.forEach(function (batch) {
                        let _batch = this.getBatchDetail(batch);
                        _batches.push(_batch);
                    });
                }
                return _batches;

            },

            getBatchDetail: function (batch) {

                var unitGroup = this.$signalR.units.filter(a => a.id == batch.unitGroupId);
                let _batch = {};
                if (unitGroup && unitGroup.length) {
                    _batch.name = unitGroup[0].name;
                    _batch.description = unitGroup[0].description;
                    _batch.basket = {};
                    _batch.startTime = batch.startTime.toLocaleTimeString("nl-nl", options);
                    _batch.endTime = batch.endTime.toLocaleTimeString("nl-nl", options);

                    var unit = unitGroup[0].units.filter(b => b.id == batch.unitId);
                    if (unit && unit.length) {
                        _batch.basket.nr = unit[0].nr;
                    }
                    _batch.source = batch;
                }
                return _batch;
            },
            deleteOrder: function () {
                this.$signalR.deleteOrder(this.Order);
                Swal.close();
            },
            close: function () {
                Swal.close();
            },
            setStatus: function (statusId) {

                var index = this.StatusIds.indexOf(statusId);
                var currentIndex = this.StatusIds.indexOf(this.Order.status);

                if (this.Order.status > BatchStatus.Prepared) {
                    if (statusId < BatchStatus.Prepared) {
                        return;
                    }
                } else if (index < currentIndex) {
                    return;
                }

                this.$signalR.setOrderStatus(this.Order, statusId);

                window.setTimeout(function () { Swal.close(); }, 500);

            },
            getStatusText: function (statusId) {
                return configRepository.statusText[statusId];
            },

            getAccentClass: function (statusId) {
                var className = {};
                className['accent' + statusId] = 1;

                var index = this.StatusIds.indexOf(statusId);
                var currentIndex = this.StatusIds.indexOf(this.Order.status);

                if (this.Order.status > BatchStatus.Prepared) {
                    if (statusId < BatchStatus.Prepared) {
                        className['disabled'] = true;
                    }
                } else if (index < currentIndex) {
                    className['disabled'] = true;
                }

                return className;
            },

            getStatusIconClass: function (statusId) {
                var className = {};
                className['icon'] = 1;
                className[OrderStatus[statusId]] = 1;
                return className;
            },

            /*
                Requests the server for the first available reschedule time
            */
            rescheduleTimeChanged: function () {
                // reload the next available time.
                var now = new Date();
                this.rescheduleloading = true;
                this.rescheduleDone = false;

                var date = new Date(now.getFullYear(), now.getMonth(), now.getDate(), this.selectedTime.split(":")[0], this.selectedTime.split(":")[1]);

                rescheduleRepository.getEstimatedTime(this.Order, date).then(result => {
                    this.rescheduleloading = false;
                    this.rescheduleFirstDateTime = result.firstDate;
                }).catch(error => { console.log(error); this.rescheduleloading = false; });
            },

            /*
                Reschudule command is send to the server
            */
            reschedule: function () {

                // reschedule the order
                this.rescheduleloading = true;

                rescheduleRepository.reSchedule(this.Order, this.rescheduleFirstDateTime).then(result => {
                    this.rescheduleloading = false;
                    this.rescheduleFirstDateTime = result.firstDate;
                    this.rescheduleDone = true;
                }).catch(error => { console.log(error); this.rescheduleloading = false; });
            },

            formatHour(hour, minute) {
                const formattedMinute = minute < 10 ? `0${minute}` : `${minute}`;
                return hour < 10 ? `0${hour}:${formattedMinute}` : `${hour}:${formattedMinute}`;
            }
        },

        computed: {
            addresses: function () {
                return this.Addresses;
            },

            remarksDirect: function () {
                if (this.Order.remarks) {
                    return this.Order.remarks.filter(a => a.showDirect && (a.showOn == ShowOn.Both || a.showOn == ShowOn.KitchenPlanning));
                }
                return [];
            },

            remarksAll: function () {
                return this.Order.remarks.filter(a => a.showOn == ShowOn.Both || a.showOn == ShowOn.KitchenPlanning);
            },

            accentClass: function () {
                return this.getAccentClass(this.Order.status);
            },

            statusIconClass: function () {
                return this.getStatusIconClass(this.Order.status);
            },

            detailedBatches: function () {
                var batches = [];
                var _this = this;
                this.Order.batches.forEach(function (batch) {
                    batches.push(_this.getBatchDetail(batch));
                })
                return batches;
            },

            /*
                contains the time intervalls for rescheduling
            */
            times: function () {
                return this.timeIntervals;
            },


            /**
             * Returns the products which are dishgroupholders
             **/
            dishGroupHolderProducts: function () {
                return this.Order.products.filter(product => product.isDishGroupholder);
            },

            /**
             * Returns the normal products
             **/
            normalProducts: function () {
                return this.Order.products.filter(product => !product.isDishGroupholder);
            }
        },

        mounted() {

            const hoursArray = [];
            if (this.Order.status == BatchStatus.Planned && !this.Order.fromHistorySearch) {

                var now = new Date();
                var newDate = new Date(now.getTime() + 5 * 60000);

                // get first rescedule time from server
                rescheduleRepository.getEstimatedTime(this.Order, newDate).then(result => {
                    // set the new first date tine
                    this.rescheduleFirstDateTime = result.firstDate;

                    // build the dropdown
                    const currentHour = this.rescheduleFirstDateTime.getHours();
                    const currentMinute = this.rescheduleFirstDateTime.getMinutes();
                    hoursArray.push(this.formatHour(currentHour, currentMinute));
                    for (let i = currentHour; i < 24; i++) {
                        for (let minute = 0; minute < 60; minute += 5) {
                            if (i === currentHour && minute <= currentMinute) {
                                continue;
                            }
                            const formattedHour = this.formatHour(i, minute);
                            hoursArray.push(formattedHour);
                        }
                    }

                    this.rescheduleloading = false;
                    this.timeIntervals = hoursArray;
                    this.rescheduleReady = true;
                    this.selectedTime = hoursArray[0];

                }).catch(error => { console.log(error); this.rescheduleloading = false; });

            }
        }
    };

    export { orderDetail as default };

</script>
